import React from "react";
import { useLanguage } from "../contexts/LanguageContext";
import { useTypingEffect } from "../hooks/useTypingEffect";
import SocialIcons from "./SocialIcons";
import developerImg from "../images/developer_02.png";
import "../css/home.css";

const Home: React.FC = () => {
  const { t } = useLanguage();
  const typedText = useTypingEffect(t.typingRoles);

  return (
    <section className="home" id="home">
      <div className="container">
        <div className="home-content">
          <p className="home-greeting">{t.greeting}</p>
          <p className="home-intro">{t.introName}</p>
          <h1 className="home-name">{t.name}</h1>
          <p className="home-profession">
            <span className="home-profession-text">{t.profession}</span>
          </p>
          <p className="home-profession">
            <span className="typing-wrapper">
              <span className="typing-text">{typedText}</span>
              <span className="typing-cursor" />
            </span>
          </p>
          <SocialIcons className="home-social" />
        </div>

        <div className="home-image">
          <img src={developerImg} alt="Developer Illustration" />
        </div>
      </div>
    </section>
  );
};

export default Home;
